import React from "react";
import { motion } from "framer-motion";
import AgeGroup from "./AgeGroup";

const Program = () => {
    const ageGroups = [
        {
            title: "Ages 5 - 12",
            description: [
                "Early learners build a strong foundation in English through interactive and fun activities.",
            ],
        },
        {
            title: "Ages 13 - 18",
            description: [
                "Intermediate students develop advanced language skills for academic and personal growth.",
            ],
        },
    ];

    return (
        <section className="px-0 py-20 w-full bg-black min-h-[420px] max-sm:px-0 max-sm:py-10">
            <motion.div className="relative px-5 py-0 mx-auto my-0 max-w-screen-xl max-md:px-10 max-md:py-0 max-sm:px-5 max-sm:py-0"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: "easeOut" }}
                viewport={{ once: true }}
            >
                <div className="flex justify-between items-start gap-10 max-md:flex-col">
                    <header className="max-w-[620px] max-md:max-w-full">
                        <h1 className="text-4xl font-bold text-white leading-[50.4px] max-sm:text-3xl max-sm:leading-10">
                            <span>Explore Our</span>
                            <span className="italic"> Comprehensive </span>
                            <span>English Tuition</span>
                            <span className="italic"> Programs</span>
                        </h1>
                    </header>

                    <p className="text-lg leading-7 text-white max-w-[627px] max-md:max-w-full max-sm:text-base max-sm:leading-6 text-justify">
                        <span>
                            At iExcel International English, we offer a range of programs designed
                            to enhance your child's English skills. Our curriculum is tailored for
                            students aged 5 to 18, focusing on reading, writing, speaking, and
                            comprehension. We provide both online and in-person classes.
                        </span>
                    </p>
                </div>

                <div className="flex gap-8 ml-auto max-w-[619px] pt-5 max-md:flex-col max-md:gap-5">
                    {ageGroups.map((group, index) => (
                        <AgeGroup
                            key={index}
                            title={group.title}
                            description={group.description}
                        />
                    ))}
                </div>
            </motion.div>
        </section>
    );
};
export default Program;